import firebase from '@firebase/app';
import '@firebase/firestore';
import '@firebase/auth';
import '@firebase/storage';

const storage = firebase.storage();

function delay(n) {
  return new Promise(function (resolve) {
    setTimeout(resolve, n * 1000);
  });
}

export default async function firebaseGetImageUrl (photo, size = 512, tries = 1) {
  let resultImage = "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png";
  try {
    const list = photo.split('.');
    const name = list[0];
    const ext = list[list.length - 1];
    const link = `${name}_${size}x${size}.${ext}`;
    // storage.ref
    console.log(link)
    resultImage = await storage.ref(link).getDownloadURL();
    return resultImage;
  } catch (err) {
    if (tries > 0) {
      tries--;
      await delay(2);
      return await firebaseGetImageUrl(photo, size, tries);
    } else {
      console.warn("firebaseGetImageUrl:", err);
      return 'https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fcohenwoodworking.com%2Fwp-content%2Fuploads%2F2016%2F09%2Fimage-placeholder-500x500.jpg&f=1&nofb=1';
    }
  }
}
